import React, { useEffect, useState } from 'react';
import {
    notification, Rate,
    Skeleton,
    Tabs,
    Typography, Upload,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { AuthConsumer, logout } from 'shared/contexts/AuthContext';
import {Link, useHistory} from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import parameters from 'shared/parameters';

interface Props {
    location: any;
}

const { Title } = Typography;
export default function FrontendReviews(props: Props) {
    const { t } = useTranslation();
    const { TabPane } = Tabs;
  const history = useHistory();
//   const [activeStats,getActiveStatus] = useState(1 as number);
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
    return (
        <div className={'profile-wrapper container-fluid pl-0 pr-0'}>
            <AuthConsumer>
                {({ isAuth, updateUser, cartTime, cart, user }) => (
                    <>
                    <div className='d-md-flex'>
                        
                        <FrontendSidebar menuSelect={4} />
                        
                        <div className={'profile-tab-content-div pl-3 pr-3'} style={{width: '100%'}}>
                            <div className='reviewSection mt-3'>
                                { user?.role?.slug === 'STUDENT' ? 
                                    <Tabs>
                                        <TabPane tab={t('genDict.Course')} key={1}>
                                            <StudentCourseReviews /> 
                                        </TabPane>
                                        <TabPane tab={t('genDict.Instructor')} key={2}>
                                            <StudentInsReviews />
                                        </TabPane>
                                    </Tabs>
                                    
                                    : 
                                    <Tabs>
                                        <TabPane tab={t('genDict.Course')} key={1}>
                                            <InsCourseReviews />
                                        </TabPane>
                                        <TabPane tab={t('genDict.Instructor')} key={2}>
                                            <InsOwnReviews />
                                        </TabPane>
                                    </Tabs>
                                    
                                }
                            </div>
                        </div>
                    </div>
                    </>
                )}
            </AuthConsumer>
        </div>
    );
    
}

function StudentCourseReviews() {
    const { t } = useTranslation();
    const [reviews, setReviews] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    useEffect(() => {
        setFetching(true);
        API_SERVICE.myReviews().then(({ data: { data: { items } } }) => {
            setReviews(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#frontStudentReviewList').DataTable({
                    "language": {
                      "search": t('genDict.dataTableSearch'),
                   
                      "emptyTable": t('genDict.emptyTable'),
                      "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                      "paginate": {
                        "first":      t('genDict.first'),
                        "last":       t('genDict.last'),
                        "next":      t('genDict.next'),
                        "previous":   t('genDict.previous'),
                      },
                      "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                    
                    "infoEmpty": t('genDict.infoEmpty'),
                    }
                  });
                // } ,1000);
            });
        }).catch((e: any) => {
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
        setFetching(false);
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return <div>
        {/*@ts-ignore*/}
        <div className='bg-white p-3 br-5px'>
            <div className="row">
                <div className='col-lg-12 mb-2'>
                    {/* <h4 className=''>{t('Your Reviews')}</h4> */}
                    <h4 className=''>{t('genDict.YourReviews')}</h4>
                </div>
            <div className="col-md-12 pb-3">
                <div className="table-responsive table-br-5 box-shadow mt-2">
                    <table id='frontStudentReviewList' className="table  table-meetings table-report">
                    <thead>
                        <tr>
                            <th className="text-uppercase text-secondary">{t('genDict.course')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.review')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.rating')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.createdDate')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                        reviews && reviews.map(review => {
                            console.log('myReview',review)
                            
                            return <tr>
                                <td><Link to={`/courses/${review.course.id}`}><span>{review.course ?
                                    <span>{review.course.title}</span>
                                    : '-'}</span></Link>
                                </td>
                                <td style={{maxWidth:"600px"}}>{review.review}</td>
                                <td><span><Rate disabled allowHalf defaultValue={review.rating} /></span></td>
                                <td><span>{moment(new Date(review.created_at)).format('LLL')}</span></td>
                            </tr>
                        }) 
                    }
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
    </div>;
}
function StudentInsReviews() {
    const { t } = useTranslation();
    const [insReviews, setInsReviews] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    useEffect(() => {
        setFetching(true);
        API_SERVICE.myInsReviews().then(({ data: { data: { items } } }) => {
            setInsReviews(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#frontMyInsReviewList').DataTable({
                    "language": {
                      "search": t('genDict.dataTableSearch'),
                   
                      "emptyTable": t('genDict.emptyTable'),
                      "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                      "paginate": {
                        "first":      t('genDict.first'),
                        "last":       t('genDict.last'),
                        "next":      t('genDict.next'),
                        "previous":   t('genDict.previous'),
                      },
                      "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                    
                    "infoEmpty": t('genDict.infoEmpty'),
                    }
                  });
                // } ,1000);
            });
        }).catch((e: any) => {
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
        setFetching(false);
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return <div>
        {/*@ts-ignore*/}
        <div className='bg-white p-3 br-5px'>
            <div className="row">
                <div className='col-lg-12 mb-2'>
                    {/* <h4 className=''>{t('Your Reviews')}</h4> */}
                    <h4 className=''>{t('genDict.YourReviews')}</h4>
                </div>
            <div className="col-md-12 pb-3">
                <div className="table-responsive table-br-5 box-shadow mt-2">
                    <table id='frontMyInsReviewList' className="table  table-meetings table-report">
                    <thead>
                        <tr>
                            <th className="text-uppercase text-secondary">{t('adminInsRating.insName')}</th>
                            <th className="text-uppercase text-secondary">{t('adminInsRating.review')}</th>
                            <th className="text-uppercase text-secondary">{t('adminInsRating.rating')}</th>
                            <th className="text-uppercase text-secondary">{t('adminInsRating.createdAt')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                        insReviews && insReviews.map((insReview, index) => {
                            console.log('myInsReview',insReview)
                            
                            return <tr key={index}>
                                <td>{insReview?.instructor?.name}</td>
                                <td style={{maxWidth:"600px"}}>{insReview.review}</td>
                                <td><span><Rate disabled allowHalf defaultValue={insReview.rating} /></span></td>
                                <td><span>{moment(new Date(insReview.created_at)).format('LLL')}</span></td>
                            </tr>
                        }) 
                    }
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
    </div>;
}
function InsCourseReviews() {
    const { t } = useTranslation();
    const [insReviews, setInsReviews] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    useEffect(() => {
        setFetching(true);
        API_SERVICE.insReviews().then(({ data: { data: { items } } }) => {
            setInsReviews(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#frontInsReviewList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      
                        "emptyTable": t('genDict.emptyTable'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":       t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                     
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        }).catch((e: any) => {
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
        setFetching(false);
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return <div>
        {/*@ts-ignore*/}
        <div className='bg-white p-3 br-5px'>
            <div className="row">
                <div className='col-lg-12 mb-2'>
                    <h4 className=''>{t('genDict.yourReviews')}</h4>
                </div>
            <div className="col-md-12 pb-3">
                <div className="table-responsive table-br-5 box-shadow mt-2">
                    <table id='frontInsReviewList' className="table  table-meetings table-report">
                    <thead>
                        <tr>
                            <th className="text-uppercase text-secondary">{t('genDict.course')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.review')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.rating')}</th>
                            <th className="text-uppercase text-center text-secondary">{t('genDict.student')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.createdDate')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                        insReviews && insReviews.map(insReview => {
                            console.log('insReview',insReview)
                            
                            return <tr>
                                <td><Link to={`/courses/${insReview?.course.id}`}><span>{insReview?.course ?
                                    <span>{insReview?.course?.title}</span>
                                    : '-'}</span></Link>
                                </td>
                                <td style={{maxWidth:"600px"}}>{insReview?.review}</td>
                                <td><span><Rate disabled allowHalf defaultValue={insReview?.rating} /></span></td>
                                <td className='text-center'>{insReview?.user?.name}</td>
                                <td><span>{moment(new Date(insReview?.created_at)).format('LLL')}</span></td>
                            </tr>
                        }) 
                    }
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
    </div>;
}
function InsOwnReviews() {
    const { t } = useTranslation();
    const [insOwnReviews, setInsOwnReviews] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    useEffect(() => {
        setFetching(true);
        API_SERVICE.insOwnReviews().then(({ data: { data: { items } } }) => {
            setInsOwnReviews(items);
            console.log("ins own reviews",items)
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#InsOwnReviewList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      
                        "emptyTable": t('genDict.emptyTable'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":       t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                     
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        }).catch((e: any) => {
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
        setFetching(false);
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return <div>
    {/*@ts-ignore*/}
    <div className='bg-white p-3 br-5px'>
        <div className="row">
            <div className='col-lg-12 mb-2'>
                <h4 className=''>{t('genDict.yourReviews')}</h4>
            </div>
        <div className="col-md-12 pb-3">
            <div className="table-responsive table-br-5 box-shadow mt-2">
                <table id='InsOwnReviewList' className="table  table-meetings table-report">
                <thead>
                    <tr>
                        <th className="text-uppercase text-secondary">{t('genDict.student')}</th>
                        <th className="text-uppercase text-secondary">{t('genDict.review')}</th>
                        <th className="text-uppercase text-secondary">{t('genDict.rating')}</th>
                        <th className="text-uppercase text-secondary">{t('genDict.createdDate')}</th>
                    </tr>
                </thead>
                <tbody>
                {   
                    insOwnReviews && insOwnReviews.map(insOwnReview => {
                        console.log('insReview',insOwnReview)
                        
                        return <tr>
                            <td>{insOwnReview?.user?.name}</td>
                            <td style={{maxWidth:"600px"}}>{insOwnReview?.review}</td>
                            <td><span><Rate disabled allowHalf defaultValue={insOwnReview?.rating} /></span></td>
                            <td><span>{moment(new Date(insOwnReview?.created_at)).format('LLL')}</span></td>
                        </tr>
                    }) 
                }
                </tbody>
            </table>
            </div>
        </div>
        </div>
    </div>
</div>;
}
